import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Axios from './axios'
import AmapVue from '@amap/amap-vue'
import '@/assets/css/reset.css'
import '@/assets/css/common.scss'
import '@/assets/css/iconfont/iconfont.css'
import '@/assets/css/element-variables.scss'
import vueCookies from "vue-cookies";

import loadingCom from "@/components/loadingCom.vue"
Vue.component("loadingCom", loadingCom);
import loginCom from "@/components/loginCom.vue"
Vue.component("loginCom", loginCom)

AmapVue.config.key = 'e1528e31823f6594189efca741f987c3'
AmapVue.loadPlugins(
    'AMap.Autocomplete', 'AMap.Geocoder',
)
Vue.use(AmapVue)
Vue.use(vueCookies)
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.$axios = Axios

//公共方法
import { getFileMd5, isLogin, httpAjax, extractThumb, downFile, getImgArrayBuffer, getFilenameFromUrl, getFileExtension} from '@/common/helper/helper.js'
Vue.prototype.$helper = { getFileMd5, isLogin, httpAjax, extractThumb, downFile, getImgArrayBuffer, getFilenameFromUrl, getFileExtension}

let vue = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
export default vue
